import { useState } from 'react'
import UserService from '../services/user'

const ChangePassword = ({ onClose }) => {
  const [formData, setFormData] = useState({
    currentPassword: '',
    newPassword: '',
    confirmPassword: ''
  })
  const [loading, setLoading] = useState(false)
  const [message, setMessage] = useState(null)
  const [passwordStrength, setPasswordStrength] = useState(null)


  const handleInputChange = (e) => {
    const { name, value } = e.target
    setFormData(prev => ({ ...prev, [name]: value }))

    if (name === 'newPassword') {
      setPasswordStrength(UserService.getPasswordStrength(value))
    }

    // Clear message when user starts typing
    if (message) {
      setMessage(null)
    }
  }

  const handleSubmit = async (e) => {
    e.preventDefault()

    // Basic validation
    if (!formData.currentPassword || !formData.newPassword || !formData.confirmPassword) {
      setMessage({ type: 'error', text: 'Please fill in all fields' })
      return
    }

    if (formData.newPassword !== formData.confirmPassword) {
      setMessage({ type: 'error', text: 'New passwords do not match' })
      return
    }

    // Password validation
    const validation = UserService.validatePassword(formData.newPassword)
    if (!validation.isValid) {
      setMessage({ type: 'error', text: validation.errors.join('. ') })
      return
    }

    setLoading(true)

    try {
      const response = await UserService.changeCurrentPassword(
        formData.currentPassword,
        formData.newPassword,
        formData.confirmPassword
      )

      if (response.success) {
        setMessage({ type: 'success', text: 'Password changed successfully!' })
        setFormData({ currentPassword: '', newPassword: '', confirmPassword: '' })
        setPasswordStrength(null)

        // Close the component after success
        setTimeout(() => {
          onClose()
        }, 3000)
      } else {
        setMessage({ type: 'error', text: response.error || 'Failed to change password' })
      }
    } catch {
      setMessage({ type: 'error', text: 'Network error. Please try again.' })
    } finally {
      setLoading(false)
    }
  }

  const handleOverlayClick = (e) => {
    if (e.target === e.currentTarget) {
      onClose()
    }
  }

  return (
    <div className="modal-overlay" onClick={handleOverlayClick}>
      <div className="modal">
        <div className="modal-header">
          <h3>Change Your Password</h3>
          <button className="modal-close" onClick={onClose}>×</button>
        </div>

        <form onSubmit={handleSubmit}>
          <div className="modal-body">
            {message && (
              <div className={`${message.type}-message`}>
                {message.text}
              </div>
            )}

            <div className="form-group">
              <label htmlFor="currentPassword">Current Password</label>
              <input
                type="password"
                id="currentPassword"
                name="currentPassword"
                value={formData.currentPassword}
                onChange={handleInputChange}
                placeholder="Enter your current password"
                disabled={loading}
                required
              />
            </div>

            <div className="form-group">
              <label htmlFor="newPassword">New Password</label>
              <input
                type="password"
                id="newPassword"
                name="newPassword"
                value={formData.newPassword}
                onChange={handleInputChange}
                placeholder="Enter new password"
                disabled={loading}
                required
              />
              {passwordStrength && passwordStrength.level !== 'none' && (
                <div className="password-strength">
                  <div className="strength-bar">
                    <div
                      className="strength-fill"
                      style={{
                        width: passwordStrength.level === 'very-weak' ? '20%' :
                               passwordStrength.level === 'weak' ? '40%' :
                               passwordStrength.level === 'fair' ? '60%' :
                               passwordStrength.level === 'good' ? '80%' : '100%',
                        backgroundColor: passwordStrength.color
                      }}
                    ></div>
                  </div>
                  <div className="strength-text" style={{ color: passwordStrength.color }}>
                    {passwordStrength.text}
                  </div>
                </div>
              )}
            </div>

            <div className="form-group">
              <label htmlFor="confirmPassword">Confirm New Password</label>
              <input
                type="password"
                id="confirmPassword"
                name="confirmPassword"
                value={formData.confirmPassword}
                onChange={handleInputChange}
                placeholder="Confirm new password"
                disabled={loading}
                required
              />
            </div>
          </div>

          <div className="modal-footer">
            <button type="button" className="btn btn-secondary" onClick={onClose} disabled={loading}>
              Cancel
            </button>
            <button type="submit" className="btn btn-primary" disabled={loading}>
              {loading ? 'Updating...' : 'Update Password'}
            </button>
          </div>
        </form>
      </div>
    </div>
  )
}

export default ChangePassword